<template>
  <div class='response-history-detail atb-flex atb-flex-column'>
    <div class='atb-content-bg atb-flex atb-flex-column'>
      <div class='search'>
        <el-form :inline="true" :model="searchParam" class="atb-input" @keyup.enter.native="getList(1)" @submit.native.prevent>
          <el-form-item label="年份">
            <el-date-picker v-model="searchParam.year" type="year" format="yyyy 年" value-format="yyyy" placeholder="选择年份"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList(1)">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class='table-content atb-flex atb-flex-column'>
        <vxe-table
          class='atb-table header-table edit-table'
          border='full'
          height='100%'
          auto-resize
          resizable
          :data="tableData"
          ref="table"
          :edit-config="{trigger: 'manual', mode: 'row'}"
          :merge-cells="mergeCells"
          @cell-click="expandRow"
          @cell-dblclick="dbClickGoDetail"
        >
          <vxe-table-column field="rowNumber" width="50" title="NO."></vxe-table-column>
          <vxe-table-column field="wkNo" title="工号" width="100"></vxe-table-column>
          <vxe-table-column field="wkName" title="姓名" width="100"></vxe-table-column>
          <vxe-table-column field="year" title="年份" width="100"></vxe-table-column>
          <vxe-table-column field="department" title="部门" width="360" ></vxe-table-column>
          <vxe-table-column field="commitDate" title="提交时间" width="100">
            <template #edit="{ row }">
              <el-date-picker v-model="row.commitDate" type="date" value-format="yyyy/MM/dd"></el-date-picker>
            </template>
            <template #default="{ row }">{{row.commitDate ? new Date(row.commitDate).toLocaleDateString() : ''}}</template>
          </vxe-table-column>
          <vxe-table-column field="status" title="状态" width="120">
            <template #default="{ row }">
              <template v-if="row.status || row.status === 0">
                <el-tag v-if="row.status === 10" type="close" effect="dark">
                  {{ statusMap[row.status] || '' }}
                </el-tag>
                <el-tag v-else-if="row.status === -1" type="unstart" effect="dark">
                  {{ statusMap[row.status] || '' }}
                </el-tag>
                <el-tag v-else type="complete" effect="dark">
                  {{ statusMap[row.status] || '' }}
                </el-tag>
              </template>
            </template>
            
          </vxe-table-column>
          <vxe-table-column field="approveReason" title="审批意见" min-width="150">
            <template #default="{row}">
              <div :class="[row.expandRowFlag ? '' : 'atb-ellipsis', 'flex', 'atb-flex-items-center']">{{ row.approveReason || '无' }}</div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="" title="操作" class-name='operation' width="60" fixed="right">
            <template #default="scope">
              <el-tooltip v-if="scope.row.approveNo === loginWkNo" class='item' effect='dark' content='编辑' placement="bottom">
                <i class='icon-editor' @click.stop='goDetail({row: scope.row})'></i>
              </el-tooltip>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
       <div class='page-con atb-flex atb-flex-justify-end'>
          <vxe-pager
            background
            :current-page.sync="page.pageIndex"
            :page-size.sync="page.pageSize"
            :total="total"
            height="100%"
            @page-change="handlePageChange"
            :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Total']"
          >
          </vxe-pager>
        </div>
    </div>
    
    <el-dialog title="提示" :visible.sync="showDelTip" width="260px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="content">
        <h2>确定要删除吗</h2>
        <p>此操作会删除对应的工作项</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="del">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="showDelTip = false">取消</el-button>
      </span>
    </el-dialog>
    <el-dialog title="新增" :visible.sync="isShowAdd" v-if="isShowAdd" width="350px" :close-on-click-modal="false" :close-on-press-escape="false">
      <div>
        <el-form :model="addForm" :rules="rules" ref="form" label-width='60px' class="atb-input" label-position="right">
          <el-form-item label="年份" prop="year">
            <el-date-picker
              v-model="addForm.year"
              type="year"
              format="yyyy 年"
              value-format="yyyy"
              placeholder="选择年份"
              style="width: 100%;"
            ></el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="atb-dialog-confirm" type="primary" @click="createNew">确认</el-button>
        <el-button class="atb-dialog-cancel" type="cancel" @click="isShowAdd = false">取消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import XEUtils from 'xe-utils'
  import _ from 'lodash'
  export default {
    name: "ResponseHistoryDetail",
    data() {
      return {
        loginWkNo: '',
        wkNo: '',
        isTemporaryWkNo: false,
        searchParam: {
          year: undefined,
        },
     
        page: {
          pageIndex: 1,
          pageSize: 10
        },
        total: 0,
        tableData: [],
        statusMap: {},
        showDelTip: false,
        row:{},

        addForm: {
          year: undefined,
        },
        isShowAdd: false,

        addType: 1,
        mergeCells: [],
        toUrl: '',
      }
    },
    computed: {},
    created() {
      const userInfo = sessionStorage.getItem('userInfo');
      this.loginWkNo = userInfo ? JSON.parse(userInfo).wkNo : '';
      this.getStatus();
    },
    mounted() {
      
    },
    activated() {
      // 因页面使用 keep-alive 在此更新数据
      this.wkNo = this.$route.query.wkNo;
      this.isTemporaryWkNo = this.$route.query.isTemporaryWkNo == '1';
      this.wkName = this.$route.query.wkName || '';
      this.$store.commit('common/updateMenuName', this.wkName);
      this.$route.meta.title = this.wkName;

      if (this.firstLoad) {
        this.searchParam.year = undefined;
        this.getList(1);
      } else {
        this.getList(this.page.pageIndex);
      }

      // 参考 route.mixin.js, 区别是在不同的生命周期监听/移除事件
      if (window.history && window.history.pushState) {
        history.pushState(null, null, document.URL); //这里有没有都无所谓，最好是有以防万一
        window.addEventListener("popstate", this.goBack, false); // 回退时执行goback方法
      }
    },
    deactivated() {
      window.removeEventListener("popstate", this.goBack, false);
    },
    destroyed() {
      window.removeEventListener("popstate", this.goBack, false);
    },
    methods: {
      getStatus() {
        return this.$ajax.get(this.$api.common.getDict, { ItemType: 'ResponseStatus' }).then((res) => {
          let rows = res.data.rows || [];
          this.statusMap = {};
          rows.forEach(item => {
            this.statusMap[item.itemValue] = item.itemDesc;
          });
        });
      },
      getList(resetPage) {
        if(resetPage){
          this.page.pageIndex = 1;
        }
        let param = Object.assign({ year: this.searchParam.year || undefined, reWkNo: this.wkNo, isTemporaryWkNo: this.isTemporaryWkNo }, this.page)
        this.$ajax.post(this.$api.responsWork.history.detailList, param).then((res) => {
          let rows = res.data.data || [];
          rows.forEach(val => {
            val.expandRowFlag = false;
          });

          this.handleTableData(rows);
          this.total = res.data.total;
        });
      },
      handleTableData(rows) {
        let tableData = [];
        let mergeCells = [];
        let rowIndex = 0;
        rows.forEach((item, index) => {
          const childRows = item.responseInfos || [];
          childRows.forEach(childItem => {
            tableData.push({...childItem, rowNumber: (this.page.pageIndex - 1) * this.page.pageSize + index + 1});
          })
          const length = childRows.length;
          mergeCells.push(
            ...[
              {row: rowIndex, col: 0, rowspan: length, colspan: 1},
              {row: rowIndex, col: 1, rowspan: length, colspan: 1},
              {row: rowIndex, col: 2, rowspan: length, colspan: 1},
              {row: rowIndex, col: 3, rowspan: length, colspan: 1},
            ]
          )
          rowIndex += childRows.length;

        });
        this.tableData = tableData;
        this.mergeCells = mergeCells;
      },
      // 通用行合并函数（将相同多列数据合并为一行）
      mergeRowMethod ({ row, _rowIndex, column, visibleData }) {
        console.log(column.field);
        
        const fields = ['wkName', 'wkNo', 'year' ]
        const cellValue = row[column.field]
        if (cellValue && fields.includes(column.field)) {
          const prevRow = visibleData[_rowIndex - 1]
          let nextRow = visibleData[_rowIndex + 1]
          if (prevRow && prevRow[column.field] === cellValue) {
            return { rowspan: 0, colspan: 0 }
          } else {
            let countRowspan = 1
            while (nextRow && nextRow[column.field] === cellValue) {
              nextRow = visibleData[++countRowspan + _rowIndex]
            }
            if (countRowspan > 1) {
              return { rowspan: countRowspan, colspan: 1 }
            }
          }
        }
      },
      formatDate(value, format) {
        return XEUtils.toDateString(value, format);
      },
      expandRow({ row, rowIndex }) {
        this.tableData[rowIndex].expandRowFlag = !this.tableData[rowIndex].expandRowFlag;
        this.$refs.table.updateData(this.tableData);
      },

      handlePageChange({currentPage}) {
        this.page.pageIndex = currentPage;
        this.getList();
      },
      // 双击跳转详情页，合并行不能双击跳转
      dbClickGoDetail({row, columnIndex}) {
        if (columnIndex < 4) return false;
        if (row.status == -1) return false;
        this.goDetail({row});
      },
      goDetail({row}) {
        this.$router.push({
          path: '/response/personal/detail',
          query:{
            id: row.id,
            editStatus: 'approve'
          }
        });
      },
      goBack() {
        this.$router.go(-1); //根据其需求，回退到指定地址
        this.$store.commit('common/backNavList',{url: this.toUrl});
      }
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        // 参考 route.mixin.js
        if (from.name && !vm.$store.state.common.isBack) {
          vm.$store.commit('common/pushNavList', {
            url: from.fullPath,
            name: from.meta.title,
          });
        }
        vm.$store.commit('common/updateIsBack'); 

        if(from.path == '/manage/execute-form/index') {
          vm.firstLoad = true;
        }else {
          vm.firstLoad = false;
        }
      })
    },
    beforeRouteLeave (to, from, next) {
      // 导航离开该组件的对应路由时调用
      this.toUrl = to.fullPath;
      if(Object.keys(to.query).length===0) this.$store.commit('common/emptyNavList');
      next(true);
    },
  }
</script>
<style scoped lang='scss'>
  .response-history-detail {
    height: 100%;
    .atb-content-bg {
      flex: 1;
    }
    ::v-deep .el-dialog__body {
      padding-top: 33px !important;
      text-align: center;
      h2 {
        font-size: 18px;
        color: $--color-text-primary;
        font-weight: bold;
        margin-bottom: 10px;
      }
      p {
        color: $--color-text-regular;
      }
    }
    ::v-deep .el-dialog__footer {
      text-align: center;
    }
    ::v-deep .el-input-group__append {
      padding: 0 5px;
    }
  }
  .footer {
    text-align: right;
    margin-top: 20px;
    .select-all-program {
      margin-right: 20px;
    }
  }

</style>